import { ReactNode } from 'react';

export type TableCellRenderer = (
  rowId: string,
  column: Column,
  content: ReactNode
) => ReactNode;

export interface Column {
  label: string;
  key: string;
  format: ColumnFormat;
  width?: string;
  align?: string;
  className?: string;
  summable?: boolean;
  valueGetter?: (row: any) => number;
  colorGetter?: (row: unknown) => string;
  labelGetter?: (row: unknown) => string;
  titleGetter?: (row: unknown) => string;
  hrefGetter?: (row: unknown) => string | undefined;
  minWidth?: number;
  maxWidth?: number;
  defaultWidth?: number;
  lockVisible?: boolean;
  defaultHidden?: boolean;
  resizable?: boolean;
}

export interface Filters {
  label: string;
  key: string;
  format: FiltersFormat;
  value?: any;
}

export enum FiltersFormat {
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  NUMBER = 'NUMBER',
}

export interface ServerPagination {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  onPageChange: (page: number) => void;
}

export type SortOrder = 'ASC' | 'DESC';

export interface ServerSort {
  sortColumn: string;
  sortOrder: SortOrder;
  onSortChange: (column: string, order: SortOrder) => void;
}

export interface TableButtons {
  rowActions?: (rowId: string) => ReactNode;
  edit?: boolean;
  delete?: boolean;
  detail?: boolean;
  preview?: boolean;
  copy?: boolean;
}

export enum ColumnFormat {
  ANY = 'ANY',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  BOOLEAN = 'BOOLEAN',
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  WORKORDERTYPE = 'WORKORDERTYPE',
  STATEWORKORDER = 'STATEWORKORDER',
  KEY = 'KEY',
  OPERATORTYPE = 'OPERATORTYPE',
  STOCKMOVEMENTTYPE = 'STOCKMOVEMENTTYPE',
  ORDERSTATE = 'ORDERSTATE',
  PRICE = 'PRICE',
  INVOICESTATUS = 'INVOICESTATUS',
  VERIFACTUSTATUS = 'VERIFACTUSTATUS',
  PAIDSTATUS = 'PAIDSTATUS',
  DELIVERYNOTESTATUS = 'DELIVERYNOTESTATUS',
  WORKORDERCODE = 'WORKORDERCODE',
  RELATEDWORKORDER = 'RELATEDWORKORDER',
  SPECIALITIES = 'SPECIALITIES',
  WORKFLOWSTATE = 'WORKFLOWSTATE',
  WORKORDERSTARTTIME = 'WORKORDERSTARTTIME',
  LINK = 'LINK',
  QUALITYSTATUS = 'QUALITYSTATUS',
}

export enum ColumnnAlign {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}
